import React from "react";
import { ListView } from "antd-mobile";
import { post } from "../../utils/request";
import api from "../api";
import { getUrlParam } from "../../utils/util";

import "./index.less";

const NUM_SECTIONS = 30;
const NUM_ROWS_PER_SECTION = 30;
let pageIndex = 0;

let dataBlobs = {};
let sectionIDs = [];
let rowIDs = [];
function genData(pIndex = 0) {
  for (let i = 0; i < NUM_SECTIONS; i++) {
    const ii = pIndex * NUM_SECTIONS + i;
    const sectionName = `Section ${ii}`;
    sectionIDs.push(sectionName);
    dataBlobs[sectionName] = sectionName;
    rowIDs[ii] = [];

    for (let jj = 0; jj < NUM_ROWS_PER_SECTION; jj++) {
      const rowName = `S${ii}, R${jj}`;
      rowIDs[ii].push(rowName);
      dataBlobs[rowName] = rowName;
    }
  }
  sectionIDs = [...sectionIDs];
  rowIDs = [...rowIDs];
}
class ActivityModuleRecord extends React.Component {
  constructor(props) {
    super(props);
    const getSectionData = (dataBlob, sectionID) => dataBlob[sectionID];
    const getRowData = (dataBlob, sectionID, rowID) => dataBlob[rowID];
    const dataSource = new ListView.DataSource({
      getRowData,
      getSectionHeaderData: getSectionData,
      rowHasChanged: (row1, row2) => row1 !== row2,
      sectionHeaderHasChanged: (s1, s2) => s1 !== s2,
    });
    this.state = {
      data: [],
      height: (document.documentElement.clientHeight * 5) / 4,
      dataSource,
      isLoading: true,
      hasMore: true,
      skipCount: 0,
      pageSize: 30,
      color: "",
      activityCode: "",
      app_stoken: "",
    };
  }
  componentDidMount() {}
  componentWillMount() {
    this.setState(
      {
        color: getUrlParam("color"),
        activityCode: getUrlParam("activityCode"),
        app_stoken: getUrlParam("app_stoken"),
      },
      () => {
        this.init();
      }
    );
  }
  init() {
    sectionIDs = [];
    rowIDs = [];
    dataBlobs = {};
    pageIndex = 0;

    genData();
    this.getList();
  }
  getList() {
    const { skipCount, pageSize } = this.state;

    post({
      url: api.userMarketingPrizeList + "?app_stoken=" + this.state.app_stoken,
      data: {
        activityCode: this.state.activityCode,
        skipCount: skipCount * pageSize,
        pageSize: pageSize,
      },
    }).then(
      (res) => {
        if ((res.result === "success" && res.data) || res.data.length > 0) {
          this.setState(
            {
              data: res.data,
            },
            () => {
              if (sectionIDs.length >= res.count) {
                this.setState({
                  hasMore: false,
                });
              }

              this.setState({
                dataSource: this.state.dataSource.cloneWithRowsAndSections(
                  dataBlobs,
                  sectionIDs,
                  rowIDs
                ),
                isLoading: false,
              });
            }
          );
        } else {
        }
      },
      (res) => {
        console.log("查询列表失败", res);
      }
    );
  }
  onEndReached = (event) => {
    // load new data
    // hasMore: from backend data, indicates whether it is the last page, here is false
    if (this.state.isLoading || !this.state.hasMore) {
      return;
    }
    console.log("reach end", event);
    this.setState({ isLoading: true });
    setTimeout(() => {
      pageIndex++;
      genData(pageIndex);
      this.setState(
        {
          skipCount: pageIndex,
        },
        () => {
          this.getList(1);
        }
      );
    }, 1000);
  };

  render() {
    const { data } = this.state;
    let index = 0;
    const row = (rowData, sectionID, rowID) => {
      let obj = {};
      if (index <= data.length - 1) {
        obj = data[index++];
      } else {
        return <div></div>;
      }

      return (
        <div className="FindItem" key={rowID}>
          <div>{obj.gmtCreate}</div>
          <div>{obj.prizeName}</div>
        </div>
      );
    };
    return (
      <div
        className="ActivityModuleRecord"
        style={{ background: this.state.color || "#fff" }}
      >
        <div>
          <div className="ActivityModuleRecord_title">
            <div>时间</div>
            <div>奖励</div>
          </div>
          <ListView
            className="am-list"
            ref={(el) => (this.lv = el)}
            dataSource={this.state.dataSource}
            renderFooter={() => (
              <div style={{ padding: 30, textAlign: "center" }}>
                {this.state.isLoading ? "加载中..." : "已经到底了！"}
              </div>
            )}
            renderRow={row}
            style={{
              height: this.state.height,
              overflow: "auto",
            }}
            pageSize={30}
            onScroll={() => {
              console.log("scroll");
            }}
            scrollRenderAheadDistance={500}
            onEndReached={this.onEndReached}
            onEndReachedThreshold={30}
          />
        </div>
      </div>
    );
  }
}
export default ActivityModuleRecord;



// WEBPACK FOOTER //
// ./src/ActivityModule/record/index.js